<div class="background-style">
  <div class="container font-mobile">
    <app-alert-modal *ngIf="alertSuccess"></app-alert-modal>
    <h4 class="headspace text-center preview-form">Preview Form</h4>
    <form>
      <!-- Member Details Start-->
      <div id="member_det" class="form-group">
        <div class="col-md-12">
          <span>
            <h6 class="bold-text-title">Member Details</h6>
          </span>
        </div>
        <div class="col-md-12 space">
          <div class="col-md-6 alignleft bottom-space">
            <span><span class="bold-text">Team Member Name</span><br>
              <span class="text-secondary"> {{memberDetails.userFirstName}} {{memberDetails.userLastName}}</span>
            </span>
          </div>
          <div class="col-md-6 alignleft">
            <span><span class="bold-text">Site Location</span><br>
              <span class="text-secondary">{{selectedSite.siteName}}
                <span class="ml-1 redFont" *ngIf="selectedSite.siteName != defaultSiteLocation"> (Virtual)</span>
              </span>
            </span>
          </div>
        </div>
        <div class="col-md-12">
          <div class="col-md-6 alignleft bottom-space">
            <span><span class="bold-text">Department / Division</span><br>
              <span class="text-secondary">{{memberDetails.division}}</span>
            </span>
          </div>
          <div class="col-md-6 alignleft">
            <span><span class="bold-text">Title / Classification</span><br>
              <span class="text-secondary">{{memberDetails.classification}}</span>
            </span>
          </div>
        </div>

      </div>
      <div class="clear"></div>
      <hr>
      <!-- Member Details Ends-->

      <!-- ERG Start-->
      <div class="form-group">

        <div class="col-md-12 bpg-heading">
          <span>
            <h6 class="bold-text-title">ERG</h6>
          </span>
          <a class="edit-section" (click)="changeFun('DisableBpg');">
            <span><i class="fa fa-pencil" aria-hidden="true"></i></span>
            <span class="edit">Edit</span>
          </a>
        </div>
        <div [ngClass]="{'DisableBpg':DisableBpg}">

          <div class="col-md-12 div-top" *ngFor="let bpgs of bpg ; let i of index">
            <div class="font-family phone-style" > <label for="check{{bpgs.bpgName}}">
              <input type="checkbox" name="check{{bpgs.bpgName}}" [checked]="bpgs.checked" name="check{{bpgs.bpgName}}" id="check{{bpgs.bpgName}}" (change)="toggleCheckboxBpg($event,bpgs)">
              <span class="label-text leaderrole"></span></label>
            
              <span class="label-style checkboxtyle roles">{{bpgs.bpgName}} </span>
               <p class="desc-style" [innerHtml]="bpgs.bpgDesc">
              </p> 
              </div>
           <div *ngIf = "(bpgs.showLeadership)">
            <div class="form font-family col-md-12 div-top ">
              <label for="chairs">
                <input type="checkbox" name="chairs{{bpgs.bpgName}}" id="chairs" [checked]="bpgs.chairs" [(ngModel)]="chairs[bpgs.bpgName]" (change)="assignroles($event, bpgs)">
                <span class="label-text leaderrole"></span>
              </label>
              <span class="label-style checkbox-style roles">Chair</span>
              <label for="viceChairs">
                <input type="checkbox" name="viceChairs{{bpgs.bpgName}}" id="viceChairs" [checked]="bpgs.viceChairs" [(ngModel)]="viceChairs[bpgs.bpgName]" (change)="assignroles($event, bpgs)">
                <span class="label-text leaderrole"></span>
              </label>              
              <span class="label-style checkbox-style roles">Vice Chair</span>
              <label for="communicationsChairs">
                <input type="checkbox" name="communicationsChairs{{bpgs.bpgName}}" id="communicationsChairs" [checked]="bpgs.communicationsChairs" [(ngModel)]="communicationsChairs[bpgs.bpgName]" (change)="assignroles($event, bpgs)">
                <span class="label-text leaderrole"></span>
              </label>
              <span class="label-style checkbox-style roles">Communication Chair</span>
              <label for="financeChairs">
                <input type="checkbox" name="financeChairs{{bpgs.bpgName}}" id="financeChairs" [checked]="bpgs.financeChairs" [(ngModel)]="financeChairs[bpgs.bpgName]" (change)="assignroles($event, bpgs)">
                <span class="label-text leaderrole"></span>
              </label>
              <span class="label-style checkbox-style roles">Finance Chair</span>
            
            </div>
       
          </div>
              
             
            </div>

        </div>

      </div>
      <div class="clear"></div>
      <hr>


      <!-- ERG Ends-->

      <!-- Area of Impact start-->
      <div class="col-md-12 bpg-heading">
        <span>
          <h6 class="bold-text-title">Areas of Impact</h6>
        </span>
        <a class="edit-section" (click)="changeFun('DisableAreaOfImpact');">
          <span><i class="fa fa-pencil" aria-hidden="true"></i></span>
          <span class="edit">Edit</span>
        </a>
      </div>
      <div class="container">
        <div class="row" [ngClass]="{'DisableAreaOfImpact':DisableAreaOfImpact}">
          <aside class="col-md-6 col-lg-4 bottom-space" aria-label="Workforce Inclusion">
            <div class="card h-100">
              <article class="card-group-item">
                <header class="card-header">
                  <h6 class="title text-center bold-text">WORK FORCE INCLUSION </h6>
                </header>
                <div class="filter-content">
                  <div class="card-body">
                    <div *ngFor="let workforce of firstCategory">
                      <label class="form-check display-class">
                        <input class="form-check-input" [checked]="workforce.checked"
                          (change)="toggleCheckboxAreaOfImpact($event,workforce)" type="checkbox" value="">
                        <span class="label-text verticalAlign"></span>
                        <span class="bpg-name bold-text">{{workforce.subCategory}}</span>

                      </label>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </aside>
          <aside class="col-md-6 col-lg-4 bottom-space" aria-label="Workplace Engagement">
            <div class="card h-100">
              <article class="card-group-item">
                <header class="card-header">
                  <h6 class="title text-center bold-text">WORKPLACE ENGAGEMENT</h6>
                </header>
                <div class="filter-content">
                  <div class="card-body">
                    <div *ngFor="let workplace of secondCategory">
                      <label class="form-check display-class">
                        <input class="form-check-input" [checked]="workplace.checked"
                          (change)="toggleCheckboxAreaOfImpact($event,workplace)" type="checkbox" value="">
                        <span class="label-text verticalAlign"></span>
                        <span class="bpg-name bold-text">{{workplace.subCategory}}</span>

                      </label> 
                    </div>

                  </div>
                </div>
              </article>
            </div>

          </aside>

          <aside class="col-md-6 col-lg-4 bottom-space" aria-label="MarketPlace Connection">
            <div class="card h-100">
              <article class="card-group-item">
                <header class="card-header">
                  <h6 class="title text-center bold-text">MARKET PLACE CONNECTION</h6>
                </header>
                <div class="filter-content">
                  <div class="card-body">
                    <div *ngFor="let marketplace of thirdCategory">
                      <label class="form-check display-class">
                        <input class="form-check-input" [checked]="marketplace.checked"
                          (change)="toggleCheckboxAreaOfImpact($event,marketplace)" type="checkbox" value="">
                        <span class="label-text verticalAlign"></span>
                        <span class="bpg-name bold-text">{{marketplace.subCategory}}</span>

                      </label>
                    </div>
                  </div>
                </div>
              </article>
            </div>

          </aside>
        </div>
      </div>
      <div class="clear"></div>
      <hr>
      <!-- Area of Impact end-->

      <!-- Skills Start-->
      <div class="form-group">

        <div class="col-md-12 bpg-heading">
          <span>
            <h6 class="bold-text-title">Skills / Interests</h6>
          </span>
          <a class="edit-section" (click)="changeFun('DisableSkills');">
            <span><i class="fa fa-pencil" aria-hidden="true"></i></span>
            <span class="edit">Edit</span>
          </a>
        </div>
        <div [ngClass]="{'DisableSkills':DisableSkills}">
          <div class="col-md-6 col-lg-4 inlineFlex skill-style" *ngFor="let skills of skills">

            <label class="font-family ">
              <input type="checkbox" [checked]="skills.checked" name="check"
                (change)="toggleCheckboxSkill($event,skills)" id="check_{{skills.skillId}}"><span
                class="label-text vertical-align"></span>
              <label class="bpg-name bold-text ie-skill" for="check_{{skills.skillId}}">{{skills.skillName}}</label>
              <p class="bpg-desc-skill">{{skills.skillDesc}}</p>
            </label>

          </div>

          <div class=" col-md-4 col-md-6 col-lg-4 font-family alignment">
            <label for="exampleFormControlTextarea2">Other interest ( if any )</label>
            <textarea class="form-control rounded-0 " id="otherSKills" rows="3" placeholder="Please specify"
              [(ngModel)]="otherSKills" name="otherSKills"></textarea>
          </div>

        </div>

      </div>
      <div class="clear"></div>

      <div class="clear"></div>
      

      <p class="alert-class">{{message}}</p>
      <p class="top-space text-center">


        <button type="button" class="btn btn-danger col-sm-2 col-md-2 button-margin" (click)="cancelClick()"
          data-toggle="modal" data-target="#myModal">CANCEL</button>
        <app-confirmation-modal [PData]="msg1" (emitPass)="this[previewMethod]()" id="2"></app-confirmation-modal>
        <span class="preview"></span>
        <button type=" button" class="btn btn-danger col-sm-2 col-md-2 button-margin" data-toggle="modal"
          data-target="#myModal" (click)="saveClick()">CONFIRM</button>
      </p>
    </form>
  </div>
  <div class="clear bottom-space-submit"></div>
</div>
